"use client";

import { useI18n } from "@/providers/i18n";
import { cn } from "@/lib/utils";

export function HeroSlogan({ className }: { className?: string }) {
  const { t } = useI18n();
  return (
    <h1 className={cn("max-w-3xl text-6xl font-light leading-tight tracking-tight", className)}>
      FlowMuse
      <br />
      {t("The Best AI Canvas")}
      <br />
      {t("In The World")}
    </h1>
  );
}
